import request from '@/axios/request'

// ================== 关于我们 ==================
// 关于我们列表
export function getAboutUsList(params) {
    return request({
        url: '/query/aboutus/list',
        method: 'get',
        params: params
    })
}

// 关于我们详情
export function getAboutUsInfo(id) {
    return request({
        url: `/query/aboutus/info/${id}`,
        method: 'get'
    })
}

// ================== 联系我们 ==================
// 联系我们列表
export function getContactUsList(params) {
    return request({
        url: '/query/contactus/list',
        method: 'get',
        params: params
    })
}

// 联系我们详情
export function getContactUsInfo(id) {
    return request({
        url: `/query/contactus/info/${id}`,
        method: 'get'
    })
}

// ================== Banner ==================
// 部门Banner列表
export function getDepartmentBannerList(params) {
    return request({
        url: '/query/departmentbanner/list',
        method: 'get',
        params: params
    })
}

// 部门Banner详情
export function getDepartmentBannerInfo(id) {
    return request({
        url: `/query/departmentbanner/info/${id}`,
        method: 'get'
    })
}

// 首页Banner列表
export function getHomeBannerList(params) {
    return request({
        url: '/query/homebanner/list',
        method: 'get',
        params: params
    })
}

// 首页Banner详情
export function getHomeBannerInfo(id) {
    return request({
        url: `/query/homebanner/info/${id}`,
        method: 'get'
    })
}

// 荣誉Banner列表
export function getHonorBannerList(params) {
    return request({
        url: '/query/honorbanner/list',
        method: 'get',
        params: params
    })
}

// 里程碑Banner列表
export function getMilestoneBannerList(params) {
    return request({
        url: '/query/milestonebanner/list',
        method: 'get',
        params: params
    })
}

// ================== 首页简介 ==================
// 首页简介列表
export function getHomeIntroList(params) {
    return request({
        url: '/query/homeintro/list',
        method: 'get',
        params: params
    })
}

// ================== 留言 ==================
// 留言列表
export function getMessageList(params) {
    return request({
        url: '/query/message/list',
        method: 'get',
        params: params
    })
}

// 创建留言
export function createMessage(data) {
    return request({
        url: '/query/message/create',
        method: 'post',
        data: data
    })
}

// ================== 新闻 ==================
// 企业新闻列表
export function getNewsCompanyList(params) {
    return request({
        url: '/query/newscompany/list',
        method: 'get',
        params: params
    })
}

// 企业新闻详情
export function getNewsCompanyInfo(id) {
    return request({
        url: `/query/newscompany/info/${id}`,
        method: 'get'
    })
}

// 行业新闻列表
export function getNewsIndustryList(params) {
    return request({
        url: '/query/newsindustry/list',
        method: 'get',
        params: params
    })
}

// 行业新闻详情
export function getNewsIndustryInfo(id) {
    return request({
        url: `/query/newsindustry/info/${id}`,
        method: 'get'
    })
}

// ================== 产品分类 ==================
// 产品一级分类列表
export function getProductCategoryList(params) {
    return request({
        url: '/query/productcategory/list',
        method: 'get',
        params: params
    })
}

// 产品一级分类详情
export function getProductCategoryInfo(id) {
    return request({
        url: `/query/productcategory/info/${id}`,
        method: 'get'
    })
}

// 产品二级分类列表
export function getProductSubCategoryList(params) {
    return request({
        url: '/query/productsubcategory/list',
        method: 'get',
        params: params
    })
}

// 产品二级分类详情
export function getProductSubCategoryInfo(id) {
    return request({
        url: `/query/productsubcategory/info/${id}`,
        method: 'get'
    })
}

// ================== 产品 ==================
// 产品列表
export function getProductList(params) {
    return request({
        url: '/query/product/list',
        method: 'get',
        params: params
    })
}

// 产品详情
export function getProductInfo(id) {
    return request({
        url: `/query/product/info/${id}`,
        method: 'get'
    })
}

// 根据一级分类ID获取产品列表
export function getProductListByCategory(categoryId) {
    return request({
        url: `/query/product/listbycategory/${categoryId}`,
        method: 'get'
    })
}

// ================== 产品规格 ==================
// 产品规格列表
export function getProductSpecColumnList(params) {
    return request({
        url: '/query/productspeccolumn/list',
        method: 'get',
        params: params
    })
}

// 产品规格组列表
export function getProductSpecGroupList(params) {
    return request({
        url: '/query/productspecgroup/list',
        method: 'get',
        params: params
    })
}

// 产品规格表头列表
export function getProductSpecHeaderList(params) {
    return request({
        url: '/query/productspecheader/list',
        method: 'get',
        params: params
    })
}

// 产品规格行列表
export function getProductSpecRowList(params) {
    return request({
        url: '/query/productspecrow/list',
        method: 'get',
        params: params
    })
}

// ================== 顶部图片 ==================
// 根据备注获取顶部图片
export function getTopImgsByRemark(remark) {
    return request({
        url: `/query/topimgs/getbyremark/${remark}`,
        method: 'get'
    })
}

// ================== 解决方案分类 ==================
// 解决方案一级分类列表
export function getSolutionCategoryList(params) {
    return request({
        url: '/query/solutioncategory/list',
        method: 'get',
        params: params
    })
}

// 解决方案一级分类详情
export function getSolutionCategoryInfo(id) {
    return request({
        url: `/query/solutioncategory/info/${id}`,
        method: 'get'
    })
}

// 解决方案二级分类列表
export function getSolutionSubCategoryList(params) {
    return request({
        url: '/query/solutionsubcategory/list',
        method: 'get',
        params: params
    })
}

// 解决方案二级分类详情
export function getSolutionSubCategoryInfo(id) {
    return request({
        url: `/query/solutionsubcategory/info/${id}`,
        method: 'get'
    })
}

// ================== 兼容旧接口（保留）==================
export function getAbout(params) {
    return request({
        url: '/companyinfo/list',
        method: 'get',
        params: params
    })
}

export function createMsg(data) {
    return request({
        url: '/msg/createMsg',
        method: 'post',
        data: data
    })
}

export function getHomeBanner(params) {
    return request({
        url: '/homebanner/list',
        method: 'get',
        params: params
    })
}

export function getBusinessBanner(params) {
    return request({
        url: '/businessbanner/list',
        method: 'get',
        params: params
    })
}

export function getCallus(params) {
    return request({
        url: '/callus/list',
        method: 'get',
        params: params
    })
}

export function getArchitecture(params) {
    return request({
        url: '/architecture/list',
        method: 'get',
        params: params
    })
}

export function getChemicalindustry(params) {
    return request({
        url: '/chemicalindustry/list',
        method: 'get',
        params: params
    })
}

export function getChemicalindustryDetail(id) {
    return request({
        url: `/chemicalindustry/info/${id}`,
        method: 'get',
    })
}

export function getCorporateculture(params) {
    return request({
        url: '/corporateculture/list',
        method: 'get',
        params: params
    })
}

export function getHistory(params) {
    return request({
        url: '/history/list',
        method: 'get',
        params: params
    })
}

export function getHomemsg(params) {
    return request({
        url: '/homemsg/list',
        method: 'get',
        params: params
    })
}

export function getInvestment(params) {
    return request({
        url: '/investment/list',
        method: 'get',
        params: params
    })
}

export function getInvestmentDetail(id) {
    return request({
        url: `/investment/info/${id}`,
        method: 'get',
    })
}

export function getImgs(params) {
    return request({
        url: '/imgs/list',
        method: 'get',
        params: params
    })
}

export function getNews(params) {
    return request({
        url: '/news/list',
        method: 'get',
        params: params
    })
}

export function getNewsDetail(id) {
    return request({
        url: `/news/info/${id}`,
        method: 'get',
    })
}

export function getMember() {
    return request({
        url: '/member/list',
        method: 'get',
    })
}

export function getOverview() {
    return request({
        url: '/overview/list',
        method: 'get',
    })
}

export function getProperty(params) {
    return request({
        url: '/property/list',
        method: 'get',
        params: params
    })
}

export function getProductType() {
    return request({
        url: '/producttype/list',
        method: 'get',
    })
}
